import { getItem, setItem, removeItem } from "@lib/storage";

export const saveJsonData = async (key, jsonData) => {
  await setItem(key, JSON.stringify(jsonData));
};

export const getJsonData = async (key) => {
  return JSON.parse(await getItem(key));
};

export const removeJson = (key) => {
  try {
    removeItem(key);
  } catch (e) {
    console.warn(e);
  }
};

// KYC v2 draft persistence — keys are SCOPED to the logged-in user so one user's
// in-progress draft never leaks into another user's session (see KYC/v2/index.js).
// scopeId = auth.user.cp_db_id || auth.user.tl_id. If it's missing, drafts are
// simply not persisted (kycDraftKey returns null → callers skip storage).
export const KYC_DRAFT_BASE_KEYS = [
  "kyc_user_photo",
  "kyc_aadhar_front",
  "kyc_aadhar_back",
  "kyc_pan_image",
  "kyc_aadhar_number",
  "kyc_pan_number",
];

export const kycDraftKey = (baseKey, scopeId) =>
  scopeId ? `${baseKey}_${scopeId}` : null;

// Clear every KYC draft key for a given user (on logout and on successful submit).
export const clearKycDrafts = (scopeId) => {
  if (!scopeId) return;
  KYC_DRAFT_BASE_KEYS.forEach((baseKey) => removeJson(`${baseKey}_${scopeId}`));
};
